export type AppLocale = "en" | "de";

const LOCALE_STORAGE_KEY = "spuerhund:locale";

export const DEFAULT_LOCALE: AppLocale = "en";
export const APP_LOCALES: AppLocale[] = ["en", "de"];

export const APP_LANGUAGE_LABELS: Record<AppLocale, string> = {
  en: "English",
  de: "Deutsch",
};

function normalizeCandidate(locale: string | null | undefined) {
  if (!locale) return null;
  return locale.trim().toLowerCase();
}

export function resolveAppLocale(locale: string | null | undefined): AppLocale {
  const normalized = normalizeCandidate(locale);
  if (!normalized) return DEFAULT_LOCALE;

  const exact = APP_LOCALES.find((entry) => entry === normalized);
  if (exact) return exact;

  const language = normalized.split("-")[0];
  const fallback = APP_LOCALES.find((entry) => entry === language);
  return fallback ?? DEFAULT_LOCALE;
}

export function readStoredLocale() {
  if (typeof window === "undefined") return null;
  const storedLocale = window.localStorage.getItem(LOCALE_STORAGE_KEY);
  return storedLocale ? resolveAppLocale(storedLocale) : null;
}

export function readPreferredBrowserLocale() {
  if (typeof navigator === "undefined") return DEFAULT_LOCALE;
  const candidates = navigator.languages?.length ? navigator.languages : [navigator.language];
  for (const candidate of candidates) {
    const resolved = resolveAppLocale(candidate);
    if (APP_LOCALES.includes(resolved)) return resolved;
  }
  return DEFAULT_LOCALE;
}

export function readPreferredLocale() {
  return readStoredLocale() ?? readPreferredBrowserLocale();
}

export function persistLocale(locale: AppLocale) {
  if (typeof window === "undefined") return;
  window.localStorage.setItem(LOCALE_STORAGE_KEY, locale);
}
